/**
 * Invoke a function when hitting the bottom of the page.
 * @see http://stackoverflow.com/questions/10059888/detect-when-scroll-reaches-the-bottom-of-the-page-without-jquery
 */
angular.module('dpw.components')
    .directive('dpwInfiniteScroll', ['$window', function ($window) {
        return {
            link: function (scope, element, attrs) {

                //below taken from http://www.howtocreate.co.uk/tutorials/javascript/browserwindow
                function getScrollXY() {
                    var scrOfX = 0, scrOfY = 0;
                    if (typeof( window.pageYOffset ) == 'number') {
                        //Netscape compliant
                        scrOfY = window.pageYOffset;
                        scrOfX = window.pageXOffset;
                    } else if (document.body && ( document.body.scrollLeft || document.body.scrollTop )) {
                        //DOM compliant
                        scrOfY = document.body.scrollTop;
                        scrOfX = document.body.scrollLeft;
                    } else if (document.documentElement && ( document.documentElement.scrollLeft || document.documentElement.scrollTop )) {
                        //IE6 standards compliant mode
                        scrOfY = document.documentElement.scrollTop;
                        scrOfX = document.documentElement.scrollLeft;
                    }
                    return [scrOfX, scrOfY];
                }

                //taken from http://james.padolsey.com/javascript/get-document-height-cross-browser/
                function getDocHeight() {
                    var D = document;
                    return Math.max(
                        D.body.scrollHeight, D.documentElement.scrollHeight,
                        D.body.offsetHeight, D.documentElement.offsetHeight,
                        D.body.clientHeight, D.documentElement.clientHeight
                    );
                }

                var distanceToBottom = parseInt(attrs.distanceToBottom, 10) || 0;

                var handleScroll = _.throttle(function () {
                    if (scope.$eval(attrs.canLoad) &&
                        getDocHeight() <= getScrollXY()[1] + window.innerHeight + distanceToBottom) {
                        scope.$apply(attrs.dpwInfiniteScroll);
                    }
                }, 300);
                window.onscroll = handleScroll;
            }
        };
    }]);